export default {
  additional_game_data: null,
  casinos: {
    data: []
  },
  gameThemes: {
    data: []
  },
  gameType: {
    name: '',
    slug: ''
  },
  images: {
    background: {
      original: '',
      bg_full: '',
      bg_optimized: '',
      bg_card: ''
    },
    logo: {
      original: '',
      logo_full: '',
      logo_optimized: '',
      logo_card: ''
    }
  },
  is_active: false,
  is_game_of_the_week: false,
  is_mobile_friendly: false,
  is_new: false,
  slug: '',
  stats: {
    number_of_plays: 0
  },
  supplier: {
    name: '',
    slug: '',
    url: ''
  },
  title: '',
  offers: {
    data: []
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/store/models/game.js